import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="sb-footer" data-testid="main-footer">
      <div className="sb-container">
        <div className="sb-footer-grid">
          <div>
            <Link to="/" className="sb-logo sb-footer-logo">
              <span className="sb-logo-icon" aria-hidden="true">🏗️</span>
              <span className="sb-logo-text">
                <span className="name">StructBuild</span>
                <span className="sub">Construct</span>
              </span>
            </Link>
            <p className="sb-footer-tagline">
              Construim cu Responsabilitate — case, vile și ansambluri rezidențiale în Moldova, de peste 15 ani.
            </p>
          </div>

          <div>
            <h4>Navigare</h4>
            <ul className="sb-footer-links">
              <li><Link to="/" data-testid="footer-link-home">Acasă</Link></li>
              <li><Link to="/servicii" data-testid="footer-link-services">Servicii</Link></li>
              <li><Link to="/proiecte" data-testid="footer-link-projects">Proiecte</Link></li>
              <li><Link to="/despre" data-testid="footer-link-about">Despre Noi</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4>Contact</h4>
            <ul className="sb-footer-contact">
              <li><span aria-hidden="true">📍</span> Strada Păcurari 112, Iași 700521</li>
              <li><span aria-hidden="true">📞</span> +40 232 456 789</li>
              <li><span aria-hidden="true">📧</span> office@structbuild.ro</li>
              <li><span aria-hidden="true">⏰</span> Luni–Vineri: 08:00–17:00</li>
            </ul>
          </div>
        </div>

        <div className="sb-footer-bottom">
          © 2025 StructBuild Construct SRL. Toate drepturile rezervate. · CUI: RO12345678
        </div>
      </div>
    </footer>
  );
};

export default Footer;
